import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./config";
import Cookies from "js-cookie";

export const DashboardApi = createAsyncThunk("Dashboard", async (data) => {
  const url = baseUrl + "getDashboard";
  const token = Cookies.get("token");

  try {
    const res = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const response = res.data;
   
    if (response.status === "success") {
   
      return response.data;
    } else {
      return Promise.reject(response);
    }
  } catch (err) {
    console.error("Dashboard API Error", err);
    return Promise.reject(err);
  }
});

export const RecentMember = createAsyncThunk("RecentMember", async (data) => {
  const url = baseUrl + "RecentMember";
  const token = Cookies.get("token");

  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const response = res.data;
   
    if (response.status === "success") {
    
      return response.data;
    } else {
      return Promise.reject(response);
    }
  } catch (err) {
    console.error("Dashboard API Error", err);
    return Promise.reject(err);
  }
});

export const ActiveMembersList = createAsyncThunk("ActiveMembersList", async (data) => {
  const url = baseUrl + "ActiveMembersList";
  const token = Cookies.get("token");

  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const response = res.data;
   
    if (response.status === "success") {
    
      return response.data;
    } else {
      return Promise.reject(response);
    }
  } catch (err) {
    console.error("Dashboard API Error", err);
    return Promise.reject(err);
  }
});

export const MemberinCountrys = createAsyncThunk("MemberinCountrys", async (data) => {
  const url = baseUrl + "MemberinCountry";
  const token = Cookies.get("token");

  try {
    const res = await axios.post(url,data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const response = res.data;

   console.log(response,"response")
    if (response.status === "success") {
    
      return response.data;
    } else {
      return Promise.reject(response);
    }
  } catch (err) {
    console.error("Dashboard API Error", err);
    return Promise.reject(err);
  }
});

